import type { BusinessType, LeadPromptOffer } from '~/lib/marketing/lead-capture/lead-prompt';

import type { Localized } from './home.content';

export const QUICK_LEAD_OFFERS: Record<
  LeadPromptOffer,
  { eyebrow: Localized; heading: Localized; body: Localized }
> = {
  default: {
    eyebrow: { en: 'Talk to our team', ar: 'تواصل مع فريقنا' },
    heading: {
      en: 'We set up your venue and move your data with you',
      ar: 'نجهّز منشأتك وننقل بياناتك معك',
    },
    body: {
      en: 'Leave your WhatsApp number and our team will message you to set up online bookings, payments and ZATCA invoicing.',
      ar: 'اترك رقم واتساب وسيتواصل معك فريقنا لتجهيز الحجز الإلكتروني والمدفوعات وفوترة زاتكا.',
    },
  },
  padel: {
    eyebrow: { en: 'For padel clubs', ar: 'لأندية البادل' },
    heading: {
      en: 'Opening or running a padel club?',
      ar: 'تفتح نادي بادل أو تديره؟',
    },
    body: {
      en: 'Our team sets you up and moves your data. Leave your WhatsApp and we will show you how clubs fill courts with online booking and payments.',
      ar: 'يجهّز فريقنا نظامك وينقل بياناتك معك. اترك رقم واتساب ونريك كيف تملأ الأندية ملاعبها بالحجز والدفع الإلكتروني.',
    },
  },
  studio: {
    eyebrow: { en: 'For studios', ar: 'للاستوديوهات' },
    heading: {
      en: 'Running a pilates or yoga studio?',
      ar: 'تدير استوديو بيلاتس أو يوغا؟',
    },
    body: {
      en: 'Our team sets you up and moves your data. Leave your WhatsApp and we will show you class booking, packs and memberships in your own app.',
      ar: 'يجهّز فريقنا نظامك وينقل بياناتك معك. اترك رقم واتساب ونريك حجز الحصص والباقات والعضويات في تطبيقك الخاص.',
    },
  },
  gym: {
    eyebrow: { en: 'For gyms', ar: 'للأندية الرياضية' },
    heading: {
      en: 'Running a gym or fitness club?',
      ar: 'تدير ناديًا رياضيًا أو صالة لياقة؟',
    },
    body: {
      en: 'Our team sets you up and moves your data. Leave your WhatsApp and we will show you memberships, check-in and payments in one place.',
      ar: 'يجهّز فريقنا نظامك وينقل بياناتك معك. اترك رقم واتساب ونريك العضويات وتسجيل الدخول والمدفوعات في مكان واحد.',
    },
  },
};

export const BUSINESS_TYPE_LABELS: Record<BusinessType, Localized> = {
  courts: { en: 'Padel & courts', ar: 'بادل وملاعب' },
  gym: { en: 'Gym & fitness', ar: 'نادٍ رياضي ولياقة' },
  studio: { en: 'Pilates or yoga studio', ar: 'استوديو بيلاتس أو يوغا' },
  academy: { en: 'Sports academy', ar: 'أكاديمية رياضية' },
  club: { en: 'Membership club', ar: 'نادٍ بعضوية' },
  clinic: { en: 'Clinic', ar: 'عيادة' },
  other: { en: 'Something else', ar: 'نشاط آخر' },
};

export const QUICK_LEAD_FORM = {
  name: { en: 'Your name', ar: 'اسمك' },
  whatsapp: { en: 'WhatsApp number', ar: 'رقم واتساب' },
  businessType: { en: 'Your business', ar: 'نوع نشاطك' },
  submit: { en: 'Message me on WhatsApp', ar: 'تواصلوا معي على واتساب' },
  dismiss: { en: 'No thanks', ar: 'لا، شكرًا' },
  close: { en: 'Close', ar: 'إغلاق' },
  privacyNote: {
    en: 'We only use your number to contact you about AskFlow.',
    ar: 'نستخدم رقمك للتواصل معك بخصوص AskFlow فقط.',
  },
  privacy: { en: 'Privacy policy', ar: 'سياسة الخصوصية' },
  errors: {
    name: { en: 'Please enter your name.', ar: 'يرجى إدخال اسمك.' },
    whatsapp: {
      en: 'Please enter a valid WhatsApp number.',
      ar: 'يرجى إدخال رقم واتساب صحيح.',
    },
    businessType: { en: 'Please pick your business type.', ar: 'يرجى اختيار نوع نشاطك.' },
    submit: {
      en: 'Something went wrong. Please try again or email us.',
      ar: 'حدث خطأ. يرجى المحاولة مرة أخرى أو مراسلتنا بالبريد.',
    },
  },
  success: {
    heading: { en: 'Thanks, we will be in touch', ar: 'شكرًا، سنتواصل معك' },
    body: {
      en: 'Our team will message you on WhatsApp soon. Prefer to pick a time now?',
      ar: 'سيراسلك فريقنا على واتساب قريبًا. تفضّل اختيار موعد الآن؟',
    },
    book: { en: 'Book a call', ar: 'احجز مكالمة' },
  },
} satisfies Record<string, Localized | Record<string, Localized>>;
